import { useGoogleTagManager, useSentry } from '@/vendors/integrations'

export function useTrackingUpdate () {
  const gtm = useGoogleTagManager()
  const { withErrorHandler } = useSentry()

  const trackUpdateViewed = ({ update }) => {
    withErrorHandler(() => {
      gtm.track({
        event: 'view_update',
        ...update.to_gtm
      })
    })
  }

  return {
    trackUpdateViewed
  }
}
